module.exports = __webpack_public_path__ + "img/welcome-cube.min.2f56f894.gif";